namespace $.$$ {

	$mol_style_define( $bog_vmap_app_shelf, {

		flex: { basis: '20rem' },

		Tools: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1, basis: '6rem' },
		},

		Filter: {
			minWidth: 0,
		},

		Item_row: {
			font: { family: 'inherit', size: '.9rem' },
		},

	} )

}
